import { useThree } from "@react-three/fiber";
import { useRef } from "react";

/**
 * Initializes all light elements.
 * @returns All light elements used for the models.
 */
export default function LightElements( { x, y, z}) {
    const ambientLightRef = useRef();
    const directLightRef = useRef();
    const pointLightRef = useRef();

    useThree(({ scene }) => {
        if (directLightRef.current) {
            directLightRef.current.position.set(x !== undefined ? x : 5, y !== undefined ? y : 10, z !== undefined ? z : 0);
            directLightRef.current.target.position.set(0, 0, 0);
            directLightRef.current.castShadow = true;
            scene.add(directLightRef.current.target);
        }

        if (pointLightRef.current) {
            pointLightRef.current.power = 10;
            pointLightRef.current.position.set(0, 0.5, 0.5);
            pointLightRef.current.shadow.mapSize.x = 2048;
            pointLightRef.current.shadow.mapSize.y = 2048;
            pointLightRef.current.shadow.bias = 0.0001;
            pointLightRef.current.shadow.radius = 3;
            pointLightRef.current.castShadow = true;
        }
    });

    return <>
        <ambientLight color={0xffffff} intensity={0.66} ref={ambientLightRef} />
        <directionalLight color={0xffffff} intensity={1.0} ref={directLightRef} />
        <pointLight color={0xffffff} intensity={1} distance={0} decay={2} ref={pointLightRef} />
    </>
};